<template>
  <div class="modal_wrap on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">사용자 신고하기</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="form_txt">
              <div class="txt_1">이 사용자를 신고하시겠습니까?</div>
              <div class="txt_2">
                신고시 이 사용자의 모든 리뷰가 차단됩니다.
              </div>
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" @click="$emit('close')">닫기</button>
            <button class="btn" @click="$emit('reportUser')">
              차단하기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      reason: 1,
    };
  },
};
</script>
